//
export default {
    name: "r-dashboard-layout",
    props: {

        /**
         * 
         */
        color: {
            type: String,
            default: "indigo darken-4"
        },
    }
}